import { SVGProps, Ref, forwardRef } from 'react';

export const LockClosedOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M8.698 11.664V8.332h-1.4v3.332z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.996 9.998c0-3.495-.332-4.995-2.103-5.607C11.57 2.014 10.455 0 7.997 0 5.54 0 4.425 2.013 4.102 4.39 2.332 5.003 2 6.503 2 9.998c0 5.249.75 5.998 5.999 5.998s5.998-.75 5.998-5.998M9.898 2.555c.234.422.41.946.527 1.54-.677-.071-1.479-.096-2.427-.096-.95 0-1.751.025-2.428.096.116-.594.293-1.118.527-1.54.416-.749.983-1.155 1.9-1.155.918 0 1.485.406 1.9 1.155m-6.324 4.55c-.126.672-.175 1.591-.175 2.893s.049 2.22.175 2.892c.124.658.298.938.446 1.085s.428.322 1.085.446c.671.127 1.591.175 2.893.175s2.22-.048 2.892-.175c.657-.124.937-.298 1.085-.446.148-.147.322-.427.446-1.085.127-.671.175-1.59.175-2.892s-.049-2.221-.175-2.893c-.124-.657-.298-.937-.446-1.085s-.428-.322-1.085-.446c-.671-.126-1.591-.175-2.892-.175-1.302 0-2.222.049-2.893.175-.657.124-.937.298-1.085.446s-.322.428-.446 1.085"
                fill="currentColor"
            />
        </g>
    </svg>
));
LockClosedOutlinedSize16Glyph.displayName = 'LockClosedOutlinedSize16Glyph';
